import React, { useContext, useState } from 'react'
import VoiceAgentAssignPopup from '../../../pages/ruleBasedInbox/threadView/components/voiceAI/voiceAgentAssignPopup'
import { Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery } from '@mui/material'
import dashboardStyles from '../../../assets/styles/componentStyles/callAnalysisStyles/callAnalysisDashboard.module.scss'
import globalStyles from '../../../assets/styles/global.module.scss'
import GlobalButton from '../../utility/globalButton/button'
import IconsColor from '../../utility/iconsColor'
import GlobalPopUp from '../../utility/globalPopUp'
import { useVoiceAgentStore } from '../../../store/voiceAgentStore'
import { voiceAgentDeploymentInterface } from '../../../models/axiosModel'
import { formatCallAnalysisTimeAccordingToTimezoneUsingMoment, hasVoiceAgentManagePermission } from '../../../utils/constants'
import { UserContext, UserContextPayload } from '../../../context/userContext'
import { useNavigate, useSearchParams } from 'react-router-dom'
import agent from '../../../services/api'
import GlobalDeletePopup from '../../utility/globalDeletePopup/globalDeletePopup'
import { whiteColor } from '../../../utils/colors'
import { useGenericStore } from '../../../store/genericStore'
import { useShallow } from 'zustand/react/shallow'
import QRimage from '../../../assets/chatbotAssets/QRimage.png'
import QrCodePopup from '../../utility/qrCodePopup'

const VoiceAgentDeployments = () => {
    const innerHeight = (window.innerHeight - 115);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const agentId = searchParams.get('voice_agent_id');
    const { setFlagLoading, handleError, userDetail, apiRoutesPermissionAssignment } = useContext(UserContext) as UserContextPayload;
    const [flagUndeployPopup, setFlagUndeployPopup] = useState<boolean>(false);
    const [undeployPopupData, setUndeployPopupData] = useState<voiceAgentDeploymentInterface | null>(null);
    const [phoneNumberQR, setPhoneNumberQR] = useState<string>("");
    const [flagQrCodePopup, setFlagQrCodePopup] = useState<boolean>(false);

    const breakPoints = {
        smallScreen: useMediaQuery<boolean>('(max-width : 600px) and (min-width : 0px)'),
        flagTabletScreen: useMediaQuery<boolean>('(max-width : 900px) and (min-width : 600px)'),
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
    }

    const flagNewDeploymentPopup = useVoiceAgentStore((state) => state.flagNewDeploymentPopup);
    const voiceAgentDetail = useVoiceAgentStore((state) => state.voiceAgentDetail);
    const setFlagNewDeploymentPopup = useVoiceAgentStore((state) => state.setFlagNewDeploymentPopup);
    const getVoiceAgentDetailAPI = useVoiceAgentStore((state) => state.getVoiceAgentDetailAPI);

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const getVoiceAgentDetailsAPICall = async () => {
        const res = await getVoiceAgentDetailAPI(agentId || "");
        if(!(res.status)){
            handleError(res);
            navigate('/voiceagent')
        }
    }

    const undeployAgentConfirm = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const payload = {
            voice_agent_id: agentId || "",
            meta_integration_whatsapp_phone_number_id: Number(undeployPopupData?.meta_integration_whatsapp_phone_number_id) || 0,
            flag_assign: false
        }
        const res = await agent.assignVoiceAgent.put(payload);
        if (res?.status) {
            showSuccess("Voice Agent Undeployed from WABA.")
            setFlagUndeployPopup(false);
            setUndeployPopupData(null);
            await getVoiceAgentDetailsAPICall();
        }
        else {
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const handleUnDeploy = async (data: voiceAgentDeploymentInterface) => {
        setFlagUndeployPopup(true);
        setUndeployPopupData(data);
    }

    const onClickOfQRCode = (phoneNumber: string) => {
        setPhoneNumberQR(phoneNumber);
        setFlagQrCodePopup(true);
    }

    const onCloseOfQRCodePopup = () => {
        setFlagQrCodePopup(false);
        setPhoneNumberQR("");
    }

    return (
        <>
            <Grid container gap={1} sx={{height: `${innerHeight}px !important`, maxHeight: `${innerHeight}px`}}>
                <Grid item xs={12}>
                    <Grid container gap={2}>
                        <Grid item xs={12} textAlign={"end"}>
                            {hasVoiceAgentManagePermission(apiRoutesPermissionAssignment, userDetail) && 
                                <GlobalButton
                                    className='primaryButtonStyle'
                                    buttonText={"Deployment"}
                                    startIcon={<IconsColor iconName="plus" width="15px" height="15px" fillColor={whiteColor} />}
                                    sx={{ width: "150px" }}
                                    onClick={() => { setFlagNewDeploymentPopup(true); }}
                                />
                            }
                        </Grid>
                        <Grid item xs={12}>
                            <TableContainer sx={{borderRadius: "5px", border: "1px solid #E9E9E9", maxWidth: "100%", overflow: "auto", maxHeight: "calc(100vh - 250px)"}}>
                                <Table aria-label="simple table" stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>WABA Name</TableCell>
                                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>WABA Number</TableCell>
                                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Deployed At</TableCell>
                                            <TableCell className={dashboardStyles.tableBodyHeadingFontStyle}>Phone Number ID</TableCell>
                                            {/* <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle} ${dashboardStyles.viewButtonColumnHeadingStyle}`}></TableCell> */}
                                            {hasVoiceAgentManagePermission(apiRoutesPermissionAssignment, userDetail) && 
                                                <TableCell className={`${dashboardStyles.tableBodyHeadingFontStyle}`}></TableCell>
                                            }
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {voiceAgentDetail?.voice_agent_deployments?.map((deploy: voiceAgentDeploymentInterface, index: number) => 
                                            <TableRow className={dashboardStyles.cellRow} key={index}>
                                                <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{deploy.verified_name}</TableCell>
                                                <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>
                                                    <Grid container flexWrap={"nowrap"} alignItems={'center'} gap={1}>
                                                        {deploy.display_phone_number}
                                                        {deploy.display_phone_number && 
                                                            <img 
                                                                alt="qr_image" 
                                                                src={QRimage} 
                                                                height={"22"} 
                                                                width={"22"} 
                                                                className={`${globalStyles.clickable} ${globalStyles.displayFlexStyle}`} 
                                                                onClick={(e) => { e.stopPropagation(); onClickOfQRCode(deploy.display_phone_number) }}
                                                            />
                                                        }
                                                    </Grid>
                                                </TableCell>
                                                <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{formatCallAnalysisTimeAccordingToTimezoneUsingMoment(deploy.timestamp, userDetail.timezone_hour)}</TableCell>
                                                <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle}>{deploy.phone_number_id}</TableCell>
                                                {/* <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${dashboardStyles.viewButtonColumnStyle}`} sx={{textAlign: "end"}}>
                                                    <span className={dashboardStyles.viewButtonStyle}>Undeploy</span>
                                                </TableCell> */}
                                                {hasVoiceAgentManagePermission(apiRoutesPermissionAssignment, userDetail) && 
                                                    <TableCell className={`${dashboardStyles.tableBodySubHeadingFontStyle} ${dashboardStyles.viewButtonStyleNew}`}>
                                                        <span className={dashboardStyles.viewButtonStyle} onClick={() => handleUnDeploy(deploy)}>Undeploy</span>
                                                    </TableCell>
                                                }
                                            </TableRow>
                                        )}
                                        {voiceAgentDetail?.voice_agent_deployments && voiceAgentDetail?.voice_agent_deployments?.length == 0 &&
                                            <TableRow className={dashboardStyles.cellRow}>
                                                <TableCell className={dashboardStyles.tableBodySubHeadingFontStyle} colSpan={5} align='center'>No Data Found.</TableCell>
                                            </TableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </Grid>
                </Grid>
                {flagNewDeploymentPopup &&
                    <GlobalPopUp
                        open={flagNewDeploymentPopup}
                        onClose={() => { setFlagNewDeploymentPopup(false) }}
                        flagBackdrop
                        paperMinWidth={breakPoints.smallScreen || breakPoints.flagTabletScreen ? "90%" : "700px"}
                        paperMaxwidth={breakPoints.smallScreen || breakPoints.flagTabletScreen ? "750px" : "750px"}
                        flagShowCloseIcon={true}
                        titlePadding='0'
                        handleClose={() => { setFlagNewDeploymentPopup(false) }}
                    >
                        <VoiceAgentAssignPopup />
                    </GlobalPopUp>
                }
                {flagUndeployPopup &&
                    <GlobalDeletePopup
                        deleteDescription={`Are you sure you want to undeploy ${voiceAgentDetail?.voice_agent_name} from ${undeployPopupData?.display_phone_number}`}
                        open={flagUndeployPopup}
                        onClose={() => { setFlagUndeployPopup(false); setUndeployPopupData(null) }}
                        onDelete={() => {
                            undeployAgentConfirm()
                        }}
                    />
                }
            </Grid>

            {flagQrCodePopup && 
                <GlobalPopUp
                    open={flagQrCodePopup}
                    onClose={() => onCloseOfQRCodePopup()}
                    handleClose={() => onCloseOfQRCodePopup()}
                    flagShowCloseIcon={true}
                    paperMinWidth={breakPoints.flagSmallScreen ? "300px" : "400px"}
                    paperMaxwidth={breakPoints.flagSmallScreen ? "710px" : "500px"}
                    borderRadius='10px'
                    titlePadding='0px'
                    overflow="hidden"
                >
                    <QrCodePopup
                        phoneNumberQR={phoneNumberQR}
                    />
                </GlobalPopUp>
            } 
        </>
    )
}

export default VoiceAgentDeployments
